"use client";

import { memo } from "react";

import ErrorModal from "components/ErrorModal";
import { AcceptFileType, createSubMessage } from "utils/modalMessage.util";

const UploadErrorModal = memo(
  ({
    isOpen,
    onClose,
    acceptFileTypes,
  }: {
    isOpen: boolean;
    onClose: () => void;
    acceptFileTypes: AcceptFileType[];
  }) => {
    return (
      <ErrorModal
        isOpen={isOpen}
        onClose={onClose}
        title={"アップロードに失敗しました"}
        message={"アップロードできないファイル形式です"}
        subMessage={
          <p className="text-sm text-attention">{`※ファイル形式は${createSubMessage(acceptFileTypes)}のみ`}</p>
        }
      />
    );
  }
);

UploadErrorModal.displayName = "UploadErrorModal";

export default UploadErrorModal;
